import React from 'react'
import {
  IconSearch,
  IconCamera,
  IconVideo,
  IconSettings,
  IconHelpHexagon,
  IconSend,
} from '@tabler/icons-react'
import {
  avatar1,
  avatar2,
  avatar3,
  avatar7,
  avatar8,
  avatar9,
} from '../../assets/images'
import { Link } from 'react-router-dom'
import Breadcrumb from '../../components/common/Breadcrumb'

export default function Chat() {

  const chatItem = [
    {
      image: avatar1,
      name: "Vincent Porter",
      status: false,
      statusText: "left 7 mins ago",
    },
    {
      image: avatar2,
      name: "Aiden Chavez",
      status: true,
      statusText: "online",
      active: true,
    },
    {
      image: avatar3,
      name: "Mike Thomas",
      status: true,
      statusText: "online",
    },
    {
      image: avatar7,
      name: "Christian Kelly",
      status: false,
      statusText: "left 10 hours ago",
    },
    {
      image: avatar8,
      name: "Monica Ward",
      status: true,
      statusText: "online",
    },
    {
      image: avatar9,
      name: "Dean Henry",
      status: false,
      statusText: "offline since Oct 28",
    },
  ]

  return (
    <>
      <Breadcrumb title="Chat" path="Chat" />
      <div className='bg-bg-dark shadow-light rounded-lg flex'>
        <div className='w-[280px] md:block hidden border-r border-r-border'>
          <div className='px-20 pt-20'>
            <div className='relative w-full overflow-hidden'>
              <button aria-label="search icon" className="absolute top-[50%] translate-y-[-50%] border-r border-border left-[1px] py-[6px] px-[12px] min-h-[33px] bg-bg-light rounded-l-[3px]">
                <IconSearch className="text-text-primary w-[20px] h-[20px] stroke-[1.5]" />
              </button>
              <input type='text' id='search' name='search' placeholder='Search...' className='bg-bg-dark border border-border w-full py-[6px] pr-[12px] pl-60  min-h-[35px] rounded-[4px] placeholder:text-text-secondary focus:outline-none' />
            </div>
          </div>
          <div className='my-10 px-10 mx-10 h-[calc(100svh-224px)] overflow-auto cus-scrollbar'>
            {chatItem.map((item, key) => (
              <button key={key} className={`w-full md:px-15 px-10 py-10 rounded-[3px] hover:bg-bg-light-100 ${item.active ? 'bg-bg-light-100' : ''}`}>
                <div className='flex items-center gap-2'>
                  <img src={item.image} alt='profile' width="45" height="45" className='w-[45px] h-[45px] object-cover rounded-full' />
                  <div className='text-left'>
                    <p className='text-[15px]/[22px] text-text-primary'>
                      {item.name}
                    </p>
                    <p className='text-[13px]/[19px] text-text-secondary flex items-center gap-5'>
                      <span className={`inline-block w-[7px] h-[7px] rounded-full ${item.status ? 'bg-success' : 'bg-pink'}`}></span>
                      {item.statusText}
                    </p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
        <div className='md:w-[calc(100%-280px)] w-full'>
          <div className='md:px-20 px-15 md:py-15 py-10 border-b border-b-border flex items-center justify-between gap-15'>
            <div className='flex items-center gap-10'>
              <Link to="#">
                <img src={avatar2} alt='profile' width="40" height="40" className='w-[40px] h-[40px] min-w-[40px] min-h-[40px] object-cover rounded-full' />
              </Link>
              <div>
                <p className='text-text-primary'>
                  <Link to="#" className='text-[16px]/[20px] font-medium'>
                    Aiden Chavez
                  </Link>
                </p>
                <small className='text-text-secondary'>
                  Last seen: 2 hours ago
                </small>
              </div>
            </div>
            <div className='gap-5 md:flex hidden'>
              <button aria-label='chat options' className='py-[6px] px-10 rounded border border-current text-black-100'>
                <IconCamera className='stroke-[1.5] w-[18px] h-[18px]' />
              </button>
              <button aria-label='chat options' className='py-[6px] px-10 rounded border border-current text-blue'>
                <IconVideo className='stroke-[1.5] w-[18px] h-[18px]' />
              </button>
              <button aria-label='chat options' className='py-[6px] px-10 rounded border border-current text-info'>
                <IconSettings className='stroke-[1.5] w-[18px] h-[18px]' />
              </button>
              <button aria-label='chat options' className='py-[6px] px-10 rounded border border-current text-yellow'>
                <IconHelpHexagon className='stroke-[1.5] w-[18px] h-[18px]' />
              </button>
            </div>
          </div>
          <div className='md:p-10 md:m-10 p-[8px] m-[8px] md:h-[calc(100svh-317px)] h-[calc(100svh-278px)] overflow-auto cus-scrollbar'>
            <div className='flex flex-col items-end mb-30'>
              <div className='flex items-center gap-5 mb-15'>
                <p>
                  10:10 AM, Today
                </p>
                <img src={avatar7} alt='profile' width="40" height="40" className='w-[40px] h-[40px] object-cover rounded-full' />
              </div>
              <div className='bg-primary text-white md:px-20 md:py-[18px] p-15 md:text-[16px]/[26px] text-base rounded-lg relative after:content-[""] after:absolute after:bottom-full after:right-[10px] after:border-l-transparent after:border-r-transparent after:border-t-0 after:border-[10px] after:border-b-primary'>
                Hi Aiden, how are you? How is the project coming along?
              </div>
            </div>
            <div className='flex flex-col items-start mb-30'>
              <div className='flex items-center gap-5 mb-15'>
                <img src={avatar2} alt='profile' width="40" height="40" className='w-[40px] h-[40px] object-cover rounded-full' />
                <p>
                  10:12 AM, Today
                </p>
              </div>
              <div className='bg-bg-light text-text-primary md:px-20 md:py-[18px] p-15 md:text-[16px]/[26px] text-base rounded-lg relative after:content-[""] after:absolute after:bottom-full after:left-[10px] after:border-l-transparent after:border-r-transparent after:border-t-0 after:border-[10px] after:border-b-bg-light'>
                Are we meeting today?
              </div>
            </div>
            <div className='flex flex-col items-start'>
              <div className='flex items-center gap-5 mb-15'>
                <img src={avatar2} alt='profile' width="40" height="40" className='w-[40px] h-[40px] object-cover rounded-full' />
                <p>
                  10:15 AM, Today
                </p>
              </div>
              <div className='bg-bg-light text-text-primary md:px-20 md:py-[18px] p-15 md:text-[16px]/[26px] text-base rounded-lg relative after:content-[""] after:absolute after:bottom-full after:left-[10px] after:border-l-transparent after:border-r-transparent after:border-t-0 after:border-[10px] after:border-b-bg-light'>
                Project has been already finished and I have results to show you.
              </div>
            </div>
          </div>
          <div className='md:p-20 p-15'>
            <div className='relative w-full overflow-hidden'>
              <button aria-label="search icon" className="absolute top-[50%] translate-y-[-50%] border-r border-r-border left-[1px] py-[6px] px-[12px] min-h-[33px] bg-bg-light rounded-l-[3px]">
                <IconSend className="text-text-primary w-[20px] h-[20px] stroke-[1.5]" />
              </button>
              <input type='text' id='chatInput' name='chatInput' placeholder='Enter text here...' className='bg-bg-dark border border-border w-full py-[6px] pr-[12px] pl-60  min-h-[35px] rounded-[4px] placeholder:text-text-secondary focus:outline-none' />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
